module.exports = __webpack_public_path__ + "d94e20c1/img/cadBim.e369a02a.png";